import { exportToExcel } from "./exportUtils";

export const exportSiteVisitData = (siteVisits) => {
  if (!siteVisits || siteVisits.length === 0) {
    throw new Error("No site visit records available to export.");
  }

  const exportData = siteVisits.map((visit) => {
    const fullName = visit.customerName || `${visit.firstName || ""} ${visit.lastName || ""}`.trim() || "No Name";
    const count = visit.siteVisitData?.roomCount ?? (visit.siteVisitData?.rooms?.length || 0);
    
    let displayNote = visit.stageNotes?.site_visit || visit.inspectionNote || "";
    if (displayNote && typeof displayNote === 'string') {
      if (displayNote.includes(' | Note: ')) {
        displayNote = displayNote.split(' | Note: ')[1].trim();
      } else if (
        displayNote.startsWith('Lead Status changed') ||
        displayNote.startsWith('Design Status changed') ||
        displayNote.startsWith('Appointment scheduled') ||
        displayNote.startsWith('Lead assigned') ||
        displayNote.startsWith('Lead reassigned')
      ) {
        displayNote = "";
      }
    }

    return {
      "Verve ID": visit.customId || "—",
      "Customer Name": fullName,
      "Phone": visit.phoneNumber || visit.phone || "—",
      "Email": visit.email || "—",
      "Last Note": displayNote || "—",
      "Rooms": count > 0 ? count : "—"
    };
  });

  exportToExcel(exportData, {
    filename: `Site_Visit_Leads_${new Date().toISOString().split("T")[0]}`,
    sheetName: "Site Visits"
  });
};
